<template>
  <div class="container-fluid">
    <h1 class="text-white">{{message}}</h1>
  </div>
</template>

<script>

export default {
  props: {
    // Spécifie le type de l'erreur
    errorType: String,
  },
  mounted() {
    // Message différent suivant le type d'erreur passé en paramètre
    if (this.errorType === 'source') {
      this.message = 'Source Inconnue';
    } else if (this.errorType === 'hmac') {
      this.message = 'Echec de l\'authentification HMAC';
    } else if (this.errorType === 'token') {
      this.message = 'Token invalide';
    } else {
      this.message = 'Erreur Inconnue';
    }
  },
  data() {
    return {
      message: '',
    };
  },
  created() {
  },
  methods: {
  },
};
</script>
